module.exports = __webpack_public_path__ + "b0c0fb9a99f202e7611aa9f3e28c7752.png";